<template>
  <v-app>
    <h3>Группы для зачисления</h3>
    <v-alert
        dense
        text
        type="success"
        v-if="success.length">
      <ul class="list">
        <li v-for="suc in success">{{ suc }}</li>
      </ul>
    </v-alert>
    <div v-for="app in applications" class="spacing-playground pa-6">
      <v-card
          elevation="2"
          outlined
          shaped
      >
        <v-card-title>Заявление от {{ app.person }}</v-card-title>
        <v-card-text>
          <v-row><v-col><h3>Записать студентов на курс <a target="_blank" :href="'https://newmoodle.amursu.ru/course/view.php?id=' + app.course.id">{{app.course.fullname}}</a></h3></v-col></v-row>
          <v-row v-for="group in app.groups"
                 :key="group.id"
                 align="center"
                 class="mx-0">
            <v-col><h4>Номер распоряжения: {{app.course.num}}</h4></v-col>
            <v-col><h4>Группа {{group.name}}</h4></v-col>
            <v-col><h4>Людей в группе {{group.people}}</h4></v-col>
            <v-btn
                color="blue darken-1"
                text
                @click="enrollStud(group.id, app.course.id, applications.indexOf(app), app.groups.indexOf(group), group.name, app.course.fullname)"
            >
              Записать
            </v-btn>
          </v-row>
          <v-container fluid>
            <v-textarea
                counter
                label="Коментарий"
                v-model="app.message"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
              color="red darken-1"
              text
              @click="saveApplication(false, app)"
          >
            Отклонить
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              @click="saveApplication(true, app)"
          >
            Готово
          </v-btn>
        </v-card-actions>
      </v-card>
      <div></div>
    </div>
  </v-app>
</template>

<script>

import axios from "axios";

export default {
  name: "estudy_enroll",
  data: () => ({
    applications: [],
    success: [],
  }),
  computed: {},
  methods: {
    getApplications() {
      axios({
        method: 'get',
        url: `/study/group_applications`,
      }).then((response) => {
        this.applications = response.data.applications;
      }).catch((error) => {
        return error;
      });
    },
    enrollStud(group_id, course_id, index_a, index_g, group_name, course_name) {
      axios({
        method: 'post',
        url: `/study/enroll_stud/${group_id}/${course_id}`,
      }).then((response) => {
        if (response.status === 200 || response.status === 204) {
          this.applications[index_a].groups.splice(index_g, 1)
          this.success.push(`Группа ${group_name} успешно зачислена на курс ${course_name}`)
        }
      }).catch((error) => {
        return error;
      });
    },
    saveApplication(stat, app){
      this.dialog = false
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/study/update_group_application/' + app.id,
        data: {
          group_application: {
            message: app.message,
            agreed: stat
          },
        }
      }).then((response) => {
        if (response.status === 200 || response.status === 204) {
          this.getApplications()
        }
      }).catch((error) => {
        return error;
      });
    },
  },
  mounted() {
    this.getApplications()
  }
}

</script>

<style scoped>

</style>